/* eslint-disable indent */
import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import cn from 'classnames';
import { VerticalGridItem } from '../../Support/Html/Components';
import isNumber from '../../Support/Is/Number/IsNumber.support';
import { GridBlock } from '../../Support/Html/Components';

/**
 * Returns the ETA
 * @param {string} eta eta time value
 * @param {string} reviewedOnJobTime reviewedOnJobTime time value
 * @returns {string} The ETA
 * @memberof TruckInfo
 */
const getEta = (eta, reviewedOnJobTime) => {
  if (eta.trim().length > 0) {
    return eta.trim();
  }
  return reviewedOnJobTime.trim();
};

const TruckInfo = ({ classes, truck, truckIndex, totalTrucks, lang }) => {
  const options = { hour: `numeric`, minute: `numeric`, timeZone: `UTC` };
  const eta = getEta(truck.eta, truck.reviewedOnJobTime);
  const etaTime = isNumber(+eta) ? new Intl.DateTimeFormat(lang, options).format(new Date(+eta)) : `-`;
  const etaCalculatedAt = new Intl.DateTimeFormat(lang, options).format(new Date(+truck.etaCalculatedAt));

  return (
    <Grid container spacing={0}>
      <GridBlock item xs={12}>
        <Grid container alignItems="baseline" className={classes.flexWrapNowrap} spacing={1}>
          <Grid item>
            <Typography variant="h6">
              Truck {truckIndex + 1} of {totalTrucks}
            </Typography>
          </Grid>
          <Grid item>
            {truck.status === `LOADING` ? (
              <Typography className={classes.dotLoading} variant="overline">
                To go
              </Typography>
            ) : (
              <Typography variant="overline" className={classes.dotInTransit}>
                In Transit
              </Typography>
            )}
          </Grid>
          {truck.status === `LOADING` && (
            <Grid item>
              <Typography variant="overline" className={classes.greyDetails}>
                Loading
              </Typography>
            </Grid>
          )}
        </Grid>
      </GridBlock>
      <Grid item xs={12}>
        <Typography className={classes.locationLastUpdated} variant="caption">
          Location last updated at {etaCalculatedAt}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container alignItems="stretch" spacing={1}>
          <Grid item>
            <Typography className={cn(classes.opacity05)} variant="body2">
              ETA
            </Typography>
            <Typography variant="body1" className={cn(classes.truckRow)}>
              {etaTime}
            </Typography>
          </Grid>
          <VerticalGridItem classes={classes} />
          <Grid item>
            <Typography className={cn(classes.opacity05)} variant="body2">
              This Load
            </Typography>
            <Typography variant="body1" className={cn(classes.truckRow)}>
              {parseFloat(truck.loadQty).toFixed(1)}m<sup>3</sup>
            </Typography>
          </Grid>
          <VerticalGridItem classes={classes} />
          <Grid item>
            <Typography className={cn(classes.opacity05)} variant="body2">
              Truck No.
            </Typography>
            <Typography variant="body1" className={cn(classes.truckRow)}>
              {truck.truckNumber}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TruckInfo;
